import { ReactNode } from "react";
import { AioIconButton } from "../additional/aioIconButton";
import { useBlockContext } from "./BlockContentProvider";
import { REMOVE_LINE } from "./blockReducer";

interface RemoveLineButtonProps {
  aifid: string;
}

/**
 * Button to remove the current line.
 *
 * @param props - Destructured parameter object
 * @param props.aifid - The block instance id (`aifid`) identifying which line to remove.
 */
export const RemoveLineButton = ({ aifid }: RemoveLineButtonProps): ReactNode => {
  const { state, dispatch } = useBlockContext();
  const ix = state.lines.findIndex((l) => l.aifid === aifid);
  const thisLine = state.lines[ix];

  return state.disabled || (state.maxLines === 1 && state.minLines === 1) || !thisLine ? null : (
    <AioIconButton
      id={`${state.id}-${ix}-remove-line`}
      iconName={
        state.lines.length <= state.minLines || !thisLine.canRemove ? "aioxCircleRed" : "aioxMinus"
      }
      onClick={() =>
        !state.disabled &&
        state.lines.length > state.minLines &&
        thisLine.canRemove &&
        dispatch({ operation: REMOVE_LINE, aifid })
      }
      tipText="Remove line"
    />
  );
};

RemoveLineButton.displayName = "RemoveLineButton";
